// extracted by mini-css-extract-plugin
export var actions = "_qv-4";
export var item = "_qv-1";
export var price = "_qv-3";
export var quantity = "_qv-2";
export var table = "_qv-0";